import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface Job {
    active?: boolean;
    baseSalary: number;
    extraSalary: number;
    createdAt?: any;
    description: string;
    internalNumber: string;
    name: string;
    subsidiaryId: string;
    updatedAt?: any;
}

export interface JobId extends Job {
    id: string;
}

@Injectable()
export class JobService {

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.JOB_COLLECTION;
    }

    postJob(jobObject: any) {
        let jobCollection = this.afs.collection(this.collection);

        let date = new Date();
        return jobCollection.add({
            ...jobObject,
            createdAt: date,
            updatedAt: date,
            active: true,

        }).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getJobs() {
        let jobCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', true));

        let jobs = jobCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Job;

                const name = data.name;
                const description = data.description;
                const baseSalary = data.baseSalary;
                const extraSalary = data.extraSalary;

                return { id$, name, description, baseSalary, extraSalary };
            });
        }).map(object => object);

        return jobs;
    }

    getJob(id$: string) {
        let jobDocument: any = this.afs.doc(this.collection + '/' + id$);

        let job = jobDocument.valueChanges();

        return job.map(object => object);
    }

    putJob(jobObject: any, id$: string) {
        let jobCollection = this.afs.collection(this.collection);

        return jobCollection.doc(id$).update(jobObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    /*
    // Method to delete the register from DB
    delJob(id$: string) {
        this.jobDocument = this.afs.doc(this.collection + '/' + id$);

        return this.jobDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }
    */

    delJob(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        let jobCollection = this.afs.collection(this.collection);

        return jobCollection.doc(id$).update({ active: false, updatedAt: new Date() }).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }


    /* jobs: Job[] = [
        {baseSalary: 0, description: 'AUXILIAR DE LINEA', internalNumber: '1', name: 'AUXILIAR DE LINEA', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'AUXILIAR DE TERMINADOS', internalNumber: '2', name: 'AUXILIAR DE TERMINADOS', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'CHOFER', internalNumber: '3', name: 'CHOFER', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'CONTADOR', internalNumber: '4', name: 'CONTADOR', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'COORDINADOR DE PRODUCCION', internalNumber: '5', name: 'COORDINADOR DE PRODUCCION', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'FEEDER', internalNumber: '6', name: 'FEEDER', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'GERENTE DE GESTION DE CALIDAD', internalNumber: '7', name: 'GERENTE DE GESTION DE CALIDAD', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'GERENTE DE PLANTA', internalNumber: '8', name: 'GERENTE DE PLANTA', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'GERENTE DE VENTAS', internalNumber: '9', name: 'GERENTE DE VENTAS', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'INSPECTOR DE CONTROL DE CALIDAD', internalNumber: '10', name: 'INSPECTOR DE CONTROL DE CALIDAD', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'INTENDENCIA', internalNumber: '11', name: 'INTENDENCIA', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'MENSAJERO', internalNumber: '12', name: 'MENSAJERO', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'OPERADOR DE CORTE', internalNumber: '13', name: 'OPERADOR DE CORTE', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'OPERADOR DE PEGADO', internalNumber: '14', name: 'OPERADOR DE PEGADO', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'OPERADOR DE PRENSA', internalNumber: '15', name: 'OPERADOR DE PRENSA', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'OPERADOR DE PREPRENSA', internalNumber: '16', name: 'OPERADOR DE PREPRENSA', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'OPERADOR DE SUAJE', internalNumber: '17', name: 'OPERADOR DE SUAJE', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'RECEPCION', internalNumber: '18', name: 'RECEPCION', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'RESPONSABLE DE ADMINISTRACION', internalNumber: '19', name: 'RESPONSABLE DE ADMINISTRACION', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'RESPONSABLE DE ALMACEN', internalNumber: '20', name: 'RESPONSABLE DE ALMACEN', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'RESPONSABLE DE ASEGURAMIENTO DE CALIDAD', internalNumber: '21', name: 'RESPONSABLE DE ASEGURAMIENTO DE CALIDAD', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'RESPONSABLE DE CADENA DE SUMINISTROS', internalNumber: '22', name: 'RESPONSABLE DE CADENA DE SUMINISTROS', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'RESPONSABLE DE COTIZACIONES', internalNumber: '23', name: 'RESPONSABLE DE COTIZACIONES', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'RESPONSABLE DE DISEÑO Y PREPRENSA', internalNumber: '24', name: 'RESPONSABLE DE DISEÑO Y PREPRENSA', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'RESPONSABLE DE ESTRUCTURA', internalNumber: '25', name: 'RESPONSABLE DE ESTRUCTURA', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'RESPONSABLE DE MANTENIMIENTO', internalNumber: '26', name: 'RESPONSABLE DE MANTENIMIENTO', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'RESPONSABLE DE TRANSPORTE DE PLACAS', internalNumber: '27', name: 'RESPONSABLE DE TRANSPORTE DE PLACAS', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'SUPERVISOR DE PRODUCCION', internalNumber: '28', name: 'SUPERVISOR DE PRODUCCION', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
        {baseSalary: 0, description: 'VENDEDOR/DUEÑO DE PROCESOS', internalNumber: '29', name: 'VENDEDOR/DUEÑO DE PROCESOS', subsidiaryId: '3qcq4VXpRxnHgiz4ISpU'},
    ] */

}

